const translations = {
    en: {
        plansFetchError: {
            message: 'Error',
            description: 'Failed to load credit plans. Please try again later.',
        },
        paymentError: {
            message: 'Error',
            description: 'An error occurred while sending the email. Please try again or try again later.',
        },
    },
    uk: {
        plansFetchError: {
            message: 'Помилка',
            description: 'Не вдалося завантажити плани кредитів. Будь ласка, спробуйте ще раз пізніше.',
        },
        paymentError: {
            message: 'Помилка',
            description:
                'Сталася помилка під час надсилання електронного листа. Будь ласка, спробуйте ще раз або спробуйте пізніше.',
        },
    },
    it: {
        plansFetchError: {
            message: 'Errore',
            description: 'Impossibile caricare i piani di credito. Riprova più tardi.',
        },
        paymentError: {
            message: 'Errore',
            description: "Si è verificato un errore durante l'invio dell'email. Riprova più tardi.",
        },
    },
    es: {
        plansFetchError: {
            message: 'Error',
            description: 'No se pudieron cargar los planes de crédito. Inténtalo de nuevo más tarde.',
        },
        paymentError: {
            message: 'Error',
            description: 'Ocurrió un error al enviar el correo electrónico. Inténtalo de nuevo más tarde.',
        },
    },
    fr: {
        plansFetchError: {
            message: 'Erreur',
            description: 'Échec du chargement des plans de crédit. Veuillez réessayer plus tard.',
        },
        paymentError: {
            message: 'Erreur',
            description: "Une erreur s'est produite lors de l'envoi de l'e-mail. Veuillez réessayer plus tard.",
        },
    },
    de: {
        plansFetchError: {
            message: 'Fehler',
            description: 'Fehler beim Laden der Kreditpläne. Bitte versuchen Sie es später erneut.',
        },
        paymentError: {
            message: 'Fehler',
            description: 'Beim Senden der E-Mail ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.',
        },
    },
};

const getErrorTranslations = (lang, action, field) => {
    return translations[lang][action][field] || 'An error occurred';
};

export default getErrorTranslations;
